import { Button } from "@website/ui/button";
import { useMonthActions } from "@website/ui/datepicker/components/month-actions/month-actions.hook";
import styles from "@website/ui/datepicker/components/month-actions/month-actions.module.scss";
import { MonthActionsPropertiesType } from "@website/ui/datepicker/components/month-actions/month-actions.types";
import { numberConvert } from "@website/utils/number-convert";
import { FC, Fragment, memo } from "react";

const MONTH_NAMES: Record<string, Array<string>> = {
  persian: [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند"
  ],
  gregorian: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};

const MonthActions: FC<MonthActionsPropertiesType> = (properties) => {
  const { calendarLocale = "gregorian", showDates, type, view } = properties;

  const { showPreviousMonthButtonProperties, showNextMonthButtonProperties } =
    useMonthActions(properties);

  return (
    <div
      className={`${styles["container"]} ${
        view === "mobile" && type === "popover"
          ? styles["container-popover__mobile"]
          : type === "popover" && view !== "mobile"
            ? styles["container-popover"]
            : styles["container-flat"]
      } ${styles["rtl" || "ltr"]}`}
    >
      <Button
        {...showPreviousMonthButtonProperties}
        className={styles["month-button"]}
      />
      {showDates
        ? showDates.map((item, index) => (
            <Fragment key={item.month}>
              {index > 0 ? (
                <div className={styles["month-name-divider"]} />
              ) : null}
              <div
                className={`${styles["month-name"]} ${
                  type === "popover"
                    ? styles["month-name-popover"]
                    : view === "mobile"
                      ? styles["month-name-flat__mobile"]
                      : styles["month-name-flat"]
                }`}
              >
                {
                  (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[
                    item.month - 1
                  ]
                }{" "}
                {numberConvert(item.year, {
                  numberOnly: true,
                  locale: "fa"
                })}
              </div>
            </Fragment>
          ))
        : null}
      <Button
        {...showNextMonthButtonProperties}
        className={styles["month-button"]}
      />
    </div>
  );
};

const MonthActionsMemoized = memo(MonthActions);
export { MonthActionsMemoized as MonthActions };
